import renderComponentFromEl from '~/javascripts/utils/renderComponentFromEl';
import { unmountComponentAtNode } from 'react-dom';

const renderComponents = (elements) => {
  Array.from(elements).forEach((el) => {
    renderComponentFromEl(el);
  });
};

document.addEventListener('DOMContentLoaded', () => {
  if (window.BuilderEnabledPage) {
    return;
  }

  renderComponents(document.querySelectorAll('[data-component]'));
});

document.addEventListener(
  'BuilderContentLoaded',
  () => {
    renderComponents(document.querySelectorAll('[data-component]'));
  },
  {
    once: true,
  }
);

document.body.addEventListener('htmx:beforeSwap', (event) => {
  if (!event.detail.shouldSwap) {
    return;
  }

  const elements = event.detail.target.querySelectorAll('[data-component]');

  elements.forEach((el) => {
    unmountComponentAtNode(el);
  });
});

document.body.addEventListener('htmx:afterSwap', (event) => {
  renderComponents(event.detail.elt.querySelectorAll('[data-component]'));
});
